import { createSketchStrategy as sketchItemStrategy } from 'cadenza/map/classic-sketch-layer/strategy';
import { GeometryType } from 'cadenza/map/geom/geometry-type';
import { SketchObjectType } from 'cadenza/map/classic-sketch-layer/sketch-object-type';

export const sketchTypeToOpenLayersGeometryType = sketchItemStrategy({

  [SketchObjectType.IMAGE]: () => GeometryType.RECTANGLE,

  [SketchObjectType.LINE]: () => GeometryType.LINE,

  [SketchObjectType.OVAL]: () => GeometryType.OVAL,

  [SketchObjectType.POINT]: () => GeometryType.POINT,

  [SketchObjectType.POLYGON]: () => GeometryType.POLYGON,

  [SketchObjectType.POLYLINE]: () => GeometryType.LINE_STRING,

  [SketchObjectType.RECTANGLE]: () => GeometryType.RECTANGLE,

  [SketchObjectType.TEXT]: () => GeometryType.POINT

});
